export default __webpack_public_path__ + "static/media/support.23430e5a.png";